import { PeriodParams } from '@/charting_library';
import { CoinInfo } from '@/utils/types';
import { useEffect, useState } from 'react';
import { TVChartContainer } from './TVChartContainer';
import { useGetCoinInfoState } from '@/zustand-store/coin/selector';
import { CoinType } from '@/zustand-store/coin/useCoinStore';

interface TradingChartProps {
  param: CoinInfo;
}

export const TradingChart: React.FC<TradingChartProps> = ({ param }) => {
  const coinType = useGetCoinInfoState('coinType');
  const [period, setPeriod] = useState<PeriodParams>({} as PeriodParams);
  useEffect(() => {
    if (param.date !== undefined) {
      const newPeriod: PeriodParams = {
        from: Math.floor(new Date(param.date).getTime() / 1000),
        to: Math.floor(new Date().getTime() / 1000),
        // to: new Date().getTime(),
        firstDataRequest: true,
        countBack: 2,
      };
      setPeriod(newPeriod);
    }
  }, [param]);

  return (
    <>
      {param && (
        <TVChartContainer
          name={param.ticker || param.name}
          pairIndex={1704} // FIXME: PAIR INDEX HARDCODE
          token={param.token}
          customPeriodParams={period}
          isMeme={coinType === CoinType.MEME}
        />
      )}
    </>
  );
};
